import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";
import logoData from './logo.json';
import candadoData from './candado.json';
// 👇 Ajusta la ruta según tu proyecto
import { getUsuarioByUser_Id } from "../api"; 

const UserPagoVerFormCoach = ({ user, getPagosByUser_Id, nombre_completo, updatePagoBy_Id }) => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL; 
  const [pagosList, setPagosList] = useState([]); 
  const [userData, setUserData] = useState(null); // 👈 aquí guardaremos los datos del usuario

  // 🔹 Cargar pagos
  useEffect(() => {
    const userId = user;

    const fetchPagos = async () => {
      if (!userId) return;
      try {
        const pagosData = await getPagosByUser_Id(userId);
        setPagosList(Array.isArray(pagosData.data) ? pagosData.data : []);
      } catch (error) {
        console.error("Error fetching pagos:", error);
        setPagosList([]);
      }
    };

    fetchPagos();
  }, [user, getPagosByUser_Id]);

  // 🔹 Cargar datos de usuario
  useEffect(() => {
    const fetchUsuario = async () => {
      if (!user) return;
      try {
        const resp = await getUsuarioByUser_Id(user);

        setUserData(resp.data);
      } catch (error) {
        console.error("Error fetching usuario:", error);
        setUserData(null);
      }
    };

    fetchUsuario();
  }, [user]);

  const generatePDF = (pago, backgroundColor) => {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
    });
  
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const halfPageHeight = pageHeight / 2;

    // Nombre que usaremos (prioridad: userData > prop nombre_completo)
    const nombreCompletoPDF = userData?.nombre_completo || nombre_completo || "";
    const primerNombre = nombreCompletoPDF.split(" ")[0] || "";

    // Algunos datos del usuario para credencial
    const tipoSangre = userData?.sangre || "";
    const contactoEmergencia = userData?.contacto_de_emergencia || "";
    const telEmergencia = userData?.teléfono_contacto_de_emergencia || "";
    const alergias = userData?.alergias || "";
  
    // --- 🔥 PARTE 1: Número de carrera (arriba)
    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 5, 5, 45, 45);
    }


   
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(210);
    doc.text(`${user}`, pageWidth / 2, 90, { align: 'center' });
  
    doc.setFontSize(35);
    doc.text(`${primerNombre}`, pageWidth / 2, halfPageHeight - 25, { align: 'center' });

    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, pageWidth / 2, halfPageHeight - 15, { align: 'center' });
  
    doc.line(10, 110, pageWidth - 10, 110);
    doc.setLineWidth(0.5);
    doc.setLineDashPattern([1, 1], 0);
    doc.line(10, 140, pageWidth - 10, 140);
    doc.setLineDashPattern([], 0);
  
    // --- 🔥 PARTE 2: Credencial (abajo)
    const credX = 20;
    const credY = halfPageHeight - 5;
    const credWidth = 85;
    const credHeight = 54;

    // Fondo Candado
    doc.setFillColor(backgroundColor); // RGB
    doc.rect(130, credY, 60, 140, 'F');
      
    if (candadoData?.base64) {
      doc.addImage(candadoData.base64, 'PNG', 130, credY, 60, 140);
    }


    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 145, credY + 100, 35, 35);
    }

    // --- 🔥 Código de Barras (user)
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, user.toString(), {
      format: "CODE128",
      width: 2,
      height: 20,
      displayValue: false,
      margin: 0,
    });
  
    const barcodeBase64 = canvas.toDataURL("image/png");
  
    const barcodeY = halfPageHeight + 70;

    doc.setFontSize(100);
    doc.setTextColor(255, 255, 255); // blanco
    doc.text(`${user}`, 160, credY + 90, { align: 'center' });

    doc.setFontSize(20);
    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, 160, credY + 105, { align: 'center' });

    doc.addImage(barcodeBase64, 'PNG', 140, barcodeY+18, 40, 5);
    
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(credX, credY, credWidth, credHeight);
  
    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 22, credY + 3, 20, 20);
    }
  
    doc.setFontSize(14);
    doc.text("CREDENCIAL", 61, credY + 10, { align: 'center' });
    doc.text("HALCONES", 61, credY + 15, { align: 'center' });
  
    let dataY = credY + 35;
    doc.setFontSize(11);
    doc.setTextColor(0, 0, 0);

    // Nombre (primeros dos nombres/apellidos)
    doc.text(
      `${nombreCompletoPDF.split(" ").slice(0, 3).join(" ")}`,
      credX + 3,
      dataY
    );
    dataY += 5;

    // Motivo / periodo
    doc.text(`${pago.motivo_de_pago.replace('cuota ', '')}`, credX + 3, dataY);
    dataY += 5;

    doc.setFontSize(9);
    doc.text(`Número de Usuario: ${user}`, credX + 3, dataY);
    dataY += 4;
    doc.text(`Fecha Pago: ${formatDate(pago.fecha_pago)}`, credX + 3, dataY);
    dataY += 4;

    // 🔹 Datos médicos / emergencia (ejemplo)
    if (tipoSangre) {
      doc.text(`Sangre: ${tipoSangre}`, credX + 3, dataY);
      dataY += 4;
    }
    if (alergias) {
      doc.text(`Alergias: ${alergias.substring(0, 35)}`, credX + 3, dataY);
      dataY += 4;
    }
    if (contactoEmergencia) {
      doc.text(`Emergencia: ${contactoEmergencia}`, credX + 3, dataY);
      dataY += 4;
    }
    if (telEmergencia) {
      doc.text(`Tel: ${telEmergencia}`, credX + 3, dataY);
      dataY += 4;
    }
  
    // 👉 Espacio para fotografía
    doc.setDrawColor(0);
    doc.rect(79, credY + 2, 25, 30);
    doc.setFontSize(8);
    doc.text("Foto", 91.5, credY + 18, { align: 'center' });

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(credX, credY + 54, credWidth, credHeight);
  

    doc.addImage(barcodeBase64, 'PNG', 25, barcodeY, 75, 15);
    doc.setFontSize(9);
    doc.text(`Valido durante: ${pago.motivo_de_pago.replace('cuota ', '')}`, credX + 5, barcodeY + 20);
    doc.text(`Cuida tu salud en nuestra app`, credX + 5, barcodeY + 25);
    doc.text(`https://halcones-sistema.negociolocalmx.com/`, credX + 5, barcodeY + 30);

    if (logoData?.base64) {
      doc.addImage(logoData.base64, 'PNG', 25, 200, 18, 18);
    }

    doc.circle(10, 7, 3, 'F');
    doc.circle(200, 7, 3, 'F');
    doc.circle(10, 125, 3, 'F');
    doc.circle(200, 125, 3, 'F');

    doc.save(`numero_y_credencial_${nombreCompletoPDF.replace(/\s/g, "_")}_${formatDate(pago.fecha_pago)}.pdf`);
  };

  const handleEdit = async (pago) => {
    try {
      pago.receptor = pago.id_receptor;
      await updatePagoBy_Id(pago.id_pago, pago);
      setPagosList((prevList) =>
        prevList.map((item) => (item.id_pago === pago.id_pago ? pago : item))
      );
      alert("Pago actualizado con éxito.");
    } catch (error) {
      console.error("Error actualizando pago:", error);
      alert("Hubo un error al intentar actualizar el pago.");
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedList = [...pagosList];
    updatedList[index][field] = value;
    setPagosList(updatedList);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const utcDate = new Date(dateString);
    const localDate = new Date(utcDate.getTime() + 24 * 60 * 60 * 1000);
    return localDate.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const getPeriodoActivo = () => {
    // const fechaActual = new Date();
    const fechaActual = new Date(2025, 11, 15);
    const año = fechaActual.getFullYear();
    const mes = fechaActual.getMonth() + 1;
  
    if (mes >= 1 && mes <= 3) return `cuota ene-mar ${año}`;
    if (mes >= 4 && mes <= 6) return `cuota abr-jun ${año}`;
    if (mes >= 7 && mes <= 9) return `cuota jul-sep ${año}`;
    return `cuota oct-dic ${año}`;
  };
  
  const periodoActivo = getPeriodoActivo();
  const haPagadoPeriodoActivo = pagosList.some(p => p.motivo_de_pago === periodoActivo);

  // Nombre a mostrar en título (igual que en PDF)
  const nombreParaMostrar = userData?.nombre_completo || nombre_completo || "";
  const mostrar = (valor) => {
  if (!valor || valor === "" || valor === null || valor === "0000-00-00 00:00:00") 
    return "N/A";
  return valor;
};


  return (
    <div className="table-container">
      <h3>Pagos Encontrados de {nombreParaMostrar}</h3>

      <center>
        <img src={`${apiBaseUrl}/_uploads/usuario/${user}/${user}.jpg`} width="75px" alt="" />
      </center>
      <center>
        <img src={`${apiBaseUrl}/_uploads/usuario/${user}/${user}.jpeg`} width="75px" alt="" />
      </center>

      {/* 👇 Ejemplo: mostrar algunos datos básicos del usuario */}
      {userData && (
        <div style={{ margin: "10px 0", fontSize: "0.9rem" }}>
          {/* DATOS DE CONTACTO */}
          <h4>DATOS DE CONTACTO</h4>
          <p>
            <strong>Numero Halcon:</strong> {mostrar(userData[0].id_usuario)} <br />
            <strong>Alias:</strong> {mostrar(userData[0].alias)} <br />
            <strong>Usuario:</strong> {mostrar(userData[0].usuario)} <br />
            <strong>Celular personal:</strong> {mostrar(userData[0].celular_personal)} <br />
            <strong>WhatsApp:</strong> {mostrar(userData[0].whatsapp)} <br />
            <strong>Correo electrónico:</strong> {mostrar(userData[0].correo_electronico)} <br />
            <strong>Domicilio 1:</strong> {mostrar(userData[0].domicilio_1)} <br />
            <strong>Domicilio 2:</strong> {mostrar(userData[0].domicilio_2)} <br />
            <strong>Contacto de emergencia:</strong> {mostrar(userData[0].contacto_de_emergencia)} <br />
            <strong>Relación contacto de emergencia:</strong>{" "}
            {mostrar(userData[0]["relación_contacto_de_emergencia"])} <br />
            <strong>Teléfono contacto de emergencia:</strong>{" "}
            {mostrar(userData[0]["teléfono_contacto_de_emergencia"])} <br />
            <strong>Correo de contacto de emergencia:</strong>{" "}
            {mostrar(userData[0]["correo_electrónico_de_contacto_de_emergencia"])} <br />
          </p>

          {/* DATOS MÉDICOS */}
          <h4>DATOS MÉDICOS</h4>
          <p>
            <strong>Tipo de sangre:</strong> {mostrar(userData[0].sangre)} <br />
            <strong>Alergias:</strong> {mostrar(userData[0].alergias)} <br />
            <strong>Condiciones médicas:</strong> {mostrar(userData[0].condiciones_medicas)} <br />
            <strong>Medicamentos actuales:</strong> {mostrar(userData[0].medicamentos_actuales)} <br />
            <strong>Cirugías recientes:</strong> {mostrar(userData[0].cirugias_reciente)} <br />
            <strong>Seguro(s) médicos:</strong> {mostrar(userData[0].seguros_medicos)} <br />
            <strong>Seguro médico primera opción:</strong>{" "}
            {mostrar(userData[0]["seguro_medico_primera_opción"])} <br />
            <strong>Nombre de la aseguradora:</strong>{" "}
            {mostrar(userData[0].nombre_de_la_aseguradora)} <br />
            <strong>Teléfono aseguradora:</strong> {mostrar(userData[0].telefono_aseguradora)} <br />
            <strong>Póliza:</strong> {mostrar(userData[0].poliza)} <br />
            <strong>Número de seguro social (IMSS):</strong>{" "}
            {mostrar(userData[0].numero_seguro_social_imss)} <br />
            <strong>Certificado médico:</strong> {mostrar(userData[0].certificado)} <br />
          </p>

          {/* DATOS GENERALES */}
          <h4>DATOS GENERALES</h4>
          <p>
            <strong>Nombre completo:</strong> {mostrar(userData[0].nombre_completo)} <br />
            <strong>CURP:</strong> {mostrar(userData[0].curp)} <br />
            <strong>Fecha de nacimiento:</strong> {mostrar(userData[0].fecha_nacimiento)} <br />
            <strong>Género:</strong> {mostrar(userData[0].genero)} <br />
            <strong>Tipo de usuario:</strong> {mostrar(userData[0].tipo_usuario)} <br />
            <strong>Fecha de creación:</strong> {mostrar(userData[0].fecha_creacion)} <br />
            <strong>Última actualización:</strong> {mostrar(userData[0].ultima_actualizacion)} <br />
            <strong>Padrino:</strong> {mostrar(userData[0].padrino)} <br />
            <strong>Nombre padrino (id/nombre):</strong> {mostrar(userData[0].nombre_padrino)} <br />
            <strong>Reto:</strong> {mostrar(userData[0].reto)} <br />
            <strong>Estado del reto:</strong> {mostrar(userData[0].estado_reto)} <br />
          </p>
        </div>

      )}
      
      <table border="1" className="table">
        <thead className="table-th">
          <tr>
            <th>Fecha</th>
            <th>Motivo</th>
            <th>Cantidad</th>
            <th>Método</th>
            <th>Recibió</th>
            <th>Nota</th>
            <th>Recibo/ID</th>
            <th>Accion</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(pagosList) && pagosList.length > 0 ? (
            pagosList.map((pago, index) => {
              const backgroundColor =
                pago.motivo_de_pago === "cuota ene-mar 2025" ? "#c5f7d7" :
                pago.motivo_de_pago === "cuota abr-jun 2025" ? "#17d4b4" :
                pago.motivo_de_pago === "cuota jul-sep 2025" ? "#2a9db1" :
                pago.motivo_de_pago === "cuota oct-dic 2025" ? "#3065b4" :
                pago.motivo_de_pago === "cuota ene-mar 2026" ? "#ffab3d" :
                pago.motivo_de_pago === "cuota abr-jun 2026" ? "#bd7e2d" :
                "rgba(170, 170, 170, 1)";

              const color = "#000";

              return (
                <tr key={index} style={{ backgroundColor, color }}>
                  <td>{formatDate(pago.fecha_pago)}</td>
                  <td width="200px">{pago.motivo_de_pago}</td>
                  <td><center>${pago.cantidad}</center></td>
                  <td>{pago.metodo_de_pago}</td>
                  <td>{pago.receptor}</td>
                  <td>
                    <input
                      type="text"
                      value={pago.nota || ""} 
                      onChange={(e) => handleInputChange(index, "nota", e.target.value)}
                    />
                  </td>
                  <td>
                    <button onClick={() => generatePDF(pago, backgroundColor)} className="button">Recibo</button>
                  </td>
                  <td>
                    <button onClick={() => handleEdit(pago)} className="menu-button3">Editar</button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="8" style={{ backgroundColor: '#ff0000', color: 'white' }}>
                No hay aportaciones registradas.
              </td>
            </tr>
          )}
          {!haPagadoPeriodoActivo && (
            <tr>
              <td colSpan="8" style={{ backgroundColor: '#ff0000', color: 'white' }}>
                No se ha registrado el pago del período activo ({periodoActivo}).
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

UserPagoVerFormCoach.propTypes = {
  user: PropTypes.number,
  pagos: PropTypes.object,
  getPagosByUser_Id: PropTypes.func.isRequired,
  value: PropTypes.string,
  nombre_completo: PropTypes.string,
};

export default UserPagoVerFormCoach;
